module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participation-counter-placeholder"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5b2d9420!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dataVisualization/d3js/participationCounter.vue
// module id = 1724
// module chunks = 61